import VariantOptionGroupForm from '../components/VariantOptionGroupForm'

const CreateVariantOptionGroupPage = () => {
  return <VariantOptionGroupForm />
}

export default CreateVariantOptionGroupPage

